/** Bytes menschenlesbar (B/KB/MB/GB/TB) mit sinnvoller Genauigkeit. */
export function formatBytes(bytes: number): string {
  if (!bytes || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  const v = bytes / Math.pow(1024, i);
  const digits = v >= 100 || i <= 1 ? 0 : 1;
  return `${v.toFixed(digits)} ${units[i]}`;
}
